import React from 'react';
import { chip, muted } from '../time/styles';

// Shared pieces for the exit pages: the approval trail and a status badge.

const STEP = {
    APPROVED: ['Approved', '#10b981'],
    REJECTED: ['Declined', '#ef4444'],
    PENDING: ['Waiting for a decision', '#d97706'],
    WAITING: ['Not yet', '#6b7280'],
    SKIPPED: ['Not needed', '#6b7280'],
    STUCK: ['Nobody to approve', '#ef4444'],
};
const STATUS = {
    PENDING_APPROVAL: ['Waiting for approval', '#d97706'],
    APPROVED: ['Accepted', '#10b981'],
    REJECTED: ['Declined', '#ef4444'],
    WITHDRAWN: ['Withdrawn', '#6b7280'],
    COMPLETED: ['Completed', '#3b82f6'],
};

export const ExitBadge = ({ status }) => {
    const [label, color] = STATUS[status] || [status, '#6b7280'];
    return <span data-status={status} style={{ ...chip, color, borderColor: color, fontSize: 12, fontWeight: 600 }}>{label}</span>;
};

const fmt = (iso) => new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });

/** Who has to approve, in order, and where it stands. */
export const ExitSteps = ({ steps }) => (
    <ol aria-label="Approvals" style={{ margin: 0, padding: 0, listStyle: 'none', display: 'grid', gap: 8 }}>
        {steps.filter(s => s.status !== 'SKIPPED').map(s => {
            const [label, color] = STEP[s.status] || [s.status, '#6b7280'];
            const who = s.approvers.map(a => a.name).join(', ');
            return (
                <li key={s.index} data-step-status={s.status} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: '50%', background: color, marginTop: 6, flexShrink: 0 }} />
                    <div style={{ color: 'var(--text-main)', fontSize: 14 }}>
                        <strong>{s.label}</strong> <span style={{ color }}>{label}</span>
                        <div style={muted}>
                            {s.decidedByName ? `${s.decidedByName}${s.decidedAt ? `, ${fmt(s.decidedAt)}` : ''}` : who || s.reason}
                            {s.fallback && !s.decidedByName ? ' (no other approver was set up)' : ''}
                        </div>
                        {s.comment && <div style={{ ...muted, fontStyle: 'italic' }}>“{s.comment}”</div>}
                    </div>
                </li>
            );
        })}
    </ol>
);

